varying vec3 vPosition;
varying vec3 vNormal;
uniform vec3 uColor;
uniform float uTime;

void main()
{

    // Stripes
    float stripes = mod((vPosition.y - uTime * 0.2) * 0.1, 1.0);
    stripes = pow(stripes, 2.0);


    vec3 viewDirection = normalize(vPosition - cameraPosition);

    //Normal
    vec3 normal = normalize(vNormal);
    if(!gl_FrontFacing)
        normal *= - 1.0;

    //Fresnel
    // float fresnel = dot(viewDirection, normal) + 1.0;
    // fresnel = pow(fresnel, 2.0);

    float fresnel = abs(dot(viewDirection, normal));
    fresnel = pow(fresnel, 2.0);

    // Falloff
    float falloff = smoothstep(0.8, 0.0, fresnel);

     // Holographic
    float holographic = stripes * fresnel;
    holographic += fresnel * 3.3;
    holographic *= falloff;

    // Final color
    gl_FragColor = vec4(uColor, holographic);
    // holographic += fresnel * 1.25;


    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}